export type CreditPackFormData = {
  name: string;
  priceInCents: number;
  credits: number;
};

export type CreditPackValidationErrors = Partial<Record<string, string>>;

/**
 * Validates credit pack form data.
 */
export function validateCreditPackForm(
  formData: CreditPackFormData,
  messages: {
    nameRequired: string;
    priceRequired: string;
    creditsRequired: string;
  },
): CreditPackValidationErrors {
  const errors: CreditPackValidationErrors = {};

  if (!formData.name.trim()) {
    errors.name = messages.nameRequired;
  }
  if (!formData.priceInCents || formData.priceInCents <= 0) {
    errors.priceInCents = messages.priceRequired;
  }
  if (!formData.credits || formData.credits <= 0) {
    errors.credits = messages.creditsRequired;
  }

  return errors;
}

/**
 * Computes the price per credit in a credit pack.
 */
export function pricePerCredit(priceInCents: number, credits: number): number {
  if (credits <= 0) return 0;
  return priceInCents / credits;
}

/**
 * Formats a cent amount as a display string.
 */
export function formatCents(cents: number, currency: string = 'EUR'): string {
  return `${(cents / 100).toFixed(2)} ${currency.toUpperCase()}`;
}
